import { useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Paper,
  Tooltip,
} from "@mui/material";

import QrCode2Icon from "@mui/icons-material/QrCode2";
import CloseIcon from "@mui/icons-material/Close";

import { QRCodeCanvas } from "qrcode.react";

const QrMenu = () => {
  const [open, setOpen] = useState(false);

  const qrData = [
    {
      titulo: "CONOCE NUESTROS SERVICIOS",
      url: "https://centroquirurgicosanrafael.com.mx/servicios",
    },
    {
      titulo: "CONOCE LOS MÉDICOS DE NUESTRO CATÁLOGO",
      url: "https://centroquirurgicosanrafael.com.mx/medicos",
    },
    {
      titulo: "CONOCE LAS ASEGURADORAS",
      url: "https://centroquirurgicosanrafael.com.mx/seguros",
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* BOTÓN FLOTANTE */}
      <Tooltip title="Conoce nuestro sitio" placement="left">
        <Box
          onClick={handleOpen}
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="fixed"
          bottom={0}
          right={0}
          width={60}
          height={60}
          m="0 15px 15px 0"
          borderRadius="50%"
          zIndex={1300}
          bgcolor="#1976d2"
          sx={{
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            transition: "all 0.3s ease",

            "&:hover": {
              transform: "scale(1.08)",
              boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
            },
          }}
        >
          <QrCode2Icon
            sx={{
              height: "2.2em",
              width: "auto",
              color: "white",
            }}
          />
        </Box>
      </Tooltip>

      {/* MODAL */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
          },
        }}
      >
        {/* TÍTULO */}
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            position: "relative",
            pb: 1,
          }}
        >
          Conoce más sobre nosotros

          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 10,
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* CONTENIDO */}
        <DialogContent sx={{ pb: 4 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            textAlign="center"
            sx={{ mb: 4 }}
          >
            Escanea cualquiera de los siguientes códigos QR para conocer
            nuestros servicios, médicos y aseguradoras.
          </Typography>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="stretch"
            flexWrap="wrap"
            gap={3}
          >
            {qrData.map((item, index) => (
              <Paper
                key={index}
                elevation={3}
                sx={{
                  width: {
                    xs: "100%",
                    sm: 200,
                  },
                  p: 2,
                  borderRadius: 3,
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  transition: "all 0.3s ease",

                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.18)",
                  },
                }}
              >
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  sx={{
                    minHeight: 45,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  {item.titulo}
                </Typography>

                {/* QR */}
                <Box
                  component="a"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                >
                  <QRCodeCanvas
                    value={item.url}
                    size={160}
                    level="H"
                    includeMargin
                  />
                </Box>

                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ mt: 2 }}
                >
                  Escanea para acceder
                </Typography>
              </Paper>
            ))}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default QrMenu;
